import { useIntl } from 'react-intl'

import { AppLocale } from '../types/Locale'

export function useLocale() {
  const { locale } = useIntl()

  return locale as AppLocale
}
